import { Navigate } from 'react-router-dom';

/** @deprecated Use global Approval Builder at /approvals/builder */
export function HrWorkflowsPage() {
  return <Navigate to="/approvals/builder?ownerModule=HR" replace />;
}
